import { useEffect, useState } from "react";
import { localMatchClipsMayExist } from "../utils/championshipLocalClips";
import {
  getChampionshipClipUploadState,
  refreshChampionshipClipQueue,
  subscribeChampionshipClipUploads,
} from "../utils/championshipClipUploader";

/**
 * Live state of the on-phone championship clip line.
 * `onlyIfSaved` skips opening clip storage on phones that never kept a clip.
 */
export function useChampionshipClipUploads({ onlyIfSaved = false } = {}) {
  const [state, setState] = useState(getChampionshipClipUploadState);
  useEffect(() => {
    const stop = subscribeChampionshipClipUploads(setState);
    if (
      !getChampionshipClipUploadState().loaded &&
      (!onlyIfSaved || localMatchClipsMayExist())
    ) {
      void refreshChampionshipClipQueue();
    }
    return stop;
  }, [onlyIfSaved]);
  return state;
}
